import React from 'react'

import type { ReceivedBubbleProps } from '../../types'
import BubbleShell from '../_shared/BubbleShell'

/**
 * A message bubble in the recipient's treatment — light surface, left-side
 * tail, with an optional header (e.g. sender name). Use to preview how a
 * message looks *to the visitor* — including a preview of your own outgoing
 * message as the recipient will receive it (e.g. a bulk-reply confirmation).
 */
const ReceivedCard: React.FC<ReceivedBubbleProps> = ({
  text,
  tail,
  header,
  className,
}) => (
  <BubbleShell
    variant="received"
    text={text}
    tail={tail}
    header={header}
    className={className}
  />
)

export default ReceivedCard
